import {
  format,
  formatDistanceToNow,
  formatDistanceToNowStrict,
  fromUnixTime,
} from 'date-fns';

import dayjs_ from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs_.extend(utc);
dayjs_.extend(timezone);
dayjs_.extend(advancedFormat);

export const dayjs = dayjs_;

export const getCurrentTimezone = () => {
  const currentTimeZone = dayjs.tz.guess();
  const currentDate = dayjs().tz(currentTimeZone).toDate();
  const options = { timeZone: currentTimeZone, timeZoneName: 'short' };
  // @ts-ignores
  const formatter = new Intl.DateTimeFormat('en-US', options);
  const parts = formatter.formatToParts(currentDate);

  // @ts-ignores
  const timeZoneAbbr = parts.find((part) => part.type === 'timeZoneName').value;
  return timeZoneAbbr.replace('D', 'S').trim();
};

export const formatRelativeTime = (unix: number) =>
  formatDistanceToNow(fromUnixTime(unix), { addSuffix: true });

export const unixToHumanReadable = (unix: number, _format = 'PPP') =>
  format(fromUnixTime(unix), _format);

export const unixToYear = (unix: number) => fromUnixTime(unix).getFullYear();

export const unixYearsPassed = (unix: number) =>
  formatDistanceToNowStrict(fromUnixTime(unix));
